import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { Loader2 } from "lucide-react";

export function RequireRestaurant({ children }) {
  const { isRestaurant, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!isRestaurant) {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }
  return children;
}
